import React from "react";
import "./RadioOption.css";
import { useFormContext } from "react-hook-form";
import type { FieldOption, Field } from "../types";


// Props for RadioOption
export interface RadioOptionProps {
  opt: FieldOption;
  field: Field;
  validationsObject?: Record<string, any>;
}

const RadioOption: React.FC<RadioOptionProps> = (props) => {
  const form = useFormContext();
  const { opt, field, validationsObject } = props;
  const { register, setValue } = form;
  const id = `${field.name}_${opt.key}`;
  return (
    <div key={opt.key} className="radio-option">
      <label htmlFor={id} className="radio-input-container">
        <input
          id={id}
          type="radio"
          {...register(field.name, {
            ...validationsObject,
            onChange: (e) => {
              e.persist();
              setValue(field.name, e.target.value);
            },
          })}
          // value prop is needed so that the radio group remembers correctly the key of each item
          value={opt.key}
        />
        <span className="radio-checked" />
        {opt.value}
      </label>
    </div>
  );
};

export default RadioOption;
